<template>
  <RouterLink
    :to="link"
    class="item"
    :class="{ 'item--selected': isSelected || this.$route.name === link.name }"
  >
    <span class="item__icon">
      <slot name="icon" />
    </span>
    <span class="item__label"><slot /></span>
  </RouterLink>
</template>

<script>
  export default {
    name: 'Item',

    props: {
      link: {
        type: Object,
        required: true,
      },
      isSelected: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/assets/css/base/block';

  .item {
    @extend .disable-selection;
    @extend .disable-tap-highlight;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    white-space: nowrap;
    text-decoration: none;

    &:hover {
      background: $color-bg-transparent--hover;
    }

    &:active {
      background: $color-bg-transparent--active;
    }

    &--selected {
      border-top: 2px solid transparent;
      border-bottom: 2px solid $color-text-primary;

      &:hover {
        border-bottom: 2px solid $color-text-primary--hover;
      }

      &:active {
        border-bottom: 2px solid $color-text-primary--active;
      }
    }

    @media (max-width: 550px) {
      flex-direction: row;
      padding: 2px 3px;
      justify-content: flex-start;
    }

    &__icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;

      img,
      svg {
        width: 38px;
        height: 38px;
        display: block;
      }

      @media (max-width: 550px) {
        width: 40px;
        height: 40px;

        img,
        svg {
          width: 40px;
          height: 40px;
        }
      }

      @media (max-width: 400px) {
        width: 32px;
        height: 32px;

        img,
        svg {
          width: 32px;
          height: 32px;
        }
      }
    }

    &__label {
      text-align: center;
      font-size: 11px;

      @media (max-width: 550px) {
        display: none;
      }
    }
  }
</style>
